/**
 * Phase 66 Plan 04 — Full `/api/v1/provisioning` endpoint catalog.
 *
 * Plan 03 added only listProvisioningQueue; Plan 04 extends with
 * approve / reject (Phase 57 multi-tenant approve modal).
 *
 * @see PATTERNS.md §API endpoints catalog
 */

import { apiGet, apiPost } from "./client";
import type { ProvisioningEntry } from "@/types/api";

/** GET /api/v1/provisioning/queue. */
export const listProvisioningQueue = (): Promise<ProvisioningEntry[]> =>
  apiGet<ProvisioningEntry[]>("/provisioning/queue");

export interface ApproveBody {
  /** Phase 57 D-15: required circuit_id for the kiosk's tenant scope. */
  circuit_id: string;
}

/** POST /api/v1/provisioning/queue/{id}/approve. */
export const approveProvisioning = (
  id: number | string,
  body: ApproveBody,
): Promise<unknown> =>
  apiPost(
    `/provisioning/queue/${encodeURIComponent(String(id))}/approve`,
    body,
  );

/** POST /api/v1/provisioning/queue/{id}/reject. */
export const rejectProvisioning = (id: number | string): Promise<unknown> =>
  apiPost(
    `/provisioning/queue/${encodeURIComponent(String(id))}/reject`,
    {},
  );

/**
 * POST /api/v1/provisioning/queue/{id}/unreject.
 *
 * 2026-06-11 — operator escape hatch when ``reject`` was issued by
 * mistake. Backend only accepts rows currently in ``rejected`` status
 * (400 with detail string otherwise); the SPA hides the button for
 * any other row so this should only fire on legitimate restorations.
 */
export const unrejectProvisioning = (id: number | string): Promise<unknown> =>
  apiPost(
    `/provisioning/queue/${encodeURIComponent(String(id))}/unreject`,
    {},
  );
